import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Tr, Td, Label, Input } from './css';
import getFormattedPricing from '../../utils';
import FieldGuide from '../../../../form/fields/common/fieldGuide';

const Row = ({ rowData, viewType, service, setService }) => {
  const {
    fields: { addonName, unitPrice, toolTip }
  } = rowData;

  const [quantity, setQuantity] = useState(() =>
    _.get(service, `${addonName}.quantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);

  const handleQuantityChange = e => {
    const {
      target: { value }
    } = e;
    setQuantity(+value);
  };

  const getQuantity = () => {
    if (addonName !== 'Travel Fee') return quantity;
    return Math.ceil(quantity / 10);
  };

  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    setService(previousValue => {
      const updatedRatePlans = {
        ...previousValue,
        [addonName]: {
          quantity,
          unitPrice
        }
      };
      if (addonName !== 'Travel Fee') {
        const totalUnitsExcludingTravel = Object.entries(
          updatedRatePlans
        ).reduce((acc, [serviceKey, serviceObj]) => {
          if (serviceKey === 'Travel Fee') return acc;
          const { quantity: serviceQuantity } = serviceObj;
          return acc + +serviceQuantity;
        }, 0);

        if ('Travel Fee' in previousValue) {
          updatedRatePlans['Travel Fee'].quantity = totalUnitsExcludingTravel;
        } else {
          updatedRatePlans['Travel Fee'] = {
            quantity,
            unitPrice: 135
          };
        }
      }
      return updatedRatePlans;
    });
  }, [quantity, unitPrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  useEffect(() => {
    if (addonName === 'Travel Fee')
      if ('Travel Fee' in service)
        setQuantity(_.get(service, 'Travel Fee.quantity', 0));
  }, [service]);

  return (
    <Tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <Label>{addonName}</Label>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>
      <Td>
        <Input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={quantity}
          onChange={handleQuantityChange}
        />
      </Td>
      <Td>
        <Label>{getFormattedPricing(unitPrice)}</Label>
      </Td>
      <Td>
        <Label>{getFormattedPricing(unitPrice * getQuantity())}</Label>
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      addonName: PropTypes.string,
      unitPrice: PropTypes.number,
      toolTip: PropTypes.string
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  service: PropTypes.shape({}).isRequired,
  setService: PropTypes.func.isRequired
};

export default Row;
